"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _swarmplot = require("@nivo/swarmplot");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var _default = exports["default"] = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement(_swarmplot.ResponsiveSwarmPlot, _extends({
    data: [],
    colors: {
      scheme: 'pastel2'
    },
    valueScale: {
      type: 'linear',
      min: 0,
      max: 500,
      reverse: false
    },
    size: {
      key: 'volume',
      values: [4, 20],
      sizes: [6, 20]
    },
    forceStrength: 4,
    simulationIterations: 100,
    borderColor: {
      from: 'color',
      modifiers: [['darker', 0.6], ['opacity', 0.5]]
    },
    margin: {
      top: 80,
      right: 100,
      bottom: 80,
      left: 100
    },
    motionStiffness: 50,
    motionDamping: 10
  }, props));
};